import api from 'src/Utils/api';
export var submitFile = function (file) {
    var formData = new FormData();
    formData.append('file', file);
    formData.append('name', file.name);
    return api.post('/settlements/create_from_file', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};
